import { Outlet } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Banner from '@/components/banner';
import Navigation from '@/components/navbar/navigation';
import Footer from '@/components/footer';
import { Toaster } from '@/components/ui/toaster';
import GlobalChatWidget from '@/components/ui/global-chat-widget';

export default function MainLayout() {
  return (
    <Box minH='100vh' w='full' bg='bg' display='flex' flexDirection='column'>
      <Banner />
      <Navigation />
      <Box flex='1' mt={{ md: 4 }}>
        <Outlet />
        <Toaster />
        <GlobalChatWidget />
      </Box>
      <Footer />
    </Box>
  );
}
